module.exports = __webpack_public_path__ + "img/vid08.fad13387.jpg";